<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <b-form-group label-cols="3" label="Type">
      <b-form-select
        :options="TYPE_LIST"
        @change="changeProp"
        text-field="name"
        v-model="field.params.type"
        value-field="code"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Placeholder" v-if="hasPlaceholder">
      <b-form-input @change="changeProp" v-model="field.params.placeholder" />
    </b-form-group>

    <b-form-group label-cols="3" label="Tooltip">
      <b-form-input @change="changeProp" v-model="field.params.tooltip" />
    </b-form-group>

    <b-form-group label-cols="3" label="" v-if="hasDefault">
      <b-form-checkbox @input="changeProp" v-model="field.default_option"
        >Has Default</b-form-checkbox
      >
    </b-form-group>

    <b-form-group
      label-cols="3"
      label="Default Value"
      v-if="hasDefault && field.default_option"
    >
      <!-- Text fields with no time value -->
      <b-form-input
        :type="field.params.type"
        @change="changeProp"
        v-model="field.default_value"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Length" v-if="hasLength">
      <div class="row d-flex align-items-baseline">
        <div class="col-4">
          <b-form-input
            @change="changeProp"
            min="0"
            step="1"
            type="number"
            v-model="field.params.minlength"
          />
        </div>
        <div class="col-2 align-middle">To</div>
        <div class="col-4">
          <b-form-input
            @change="changeProp"
            min="0"
            step="1"
            type="number"
            v-model="field.params.maxlength"
          />
        </div>
      </div>
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import WidgetPropMixin from "../WidgetPropMixin.js";

export default {
  name: "TextProps",
  components: { WidgetCommonProps },
  mixins: [WidgetPropMixin],

  data: function () {
    var TYPE_LIST = [
      {
        code: "text",
        name: "Text",
        has_length: true,
        has_placeholder: true,
        has_default: true,
      },
      {
        code: "email",
        name: "Email",
        has_length: true,
        has_placeholder: true,
        has_default: true,
      },
      {
        code: "password",
        name: "Password",
        has_length: true,
        has_placeholder: true,
        has_default: false,
      },
      {
        code: "url",
        name: "URL",
        has_length: true,
        has_placeholder: true,
        has_default: true,
      },
      {
        code: "tel",
        name: "Telephone",
        has_length: true,
        has_placeholder: true,
        has_default: true,
      },
      {
        code: "color",
        name: "Color",
        has_length: false,
        has_placeholder: false,
      },
      // TODO: Add time text fields later
      /* {code: "week", name: "Week", has_length: false, has_placeholder: false, has_default: true, has_time: true},
              {code: "month", name: "Month", has_length: false, has_placeholder: false, has_default: true, has_time: true},
              {code: "date", name: "Date", has_length: false, has_placeholder: false, has_default: true, has_time: true},
              {code: "datetime-local", name: "Date Time", has_length: false, has_placeholder: false, has_default: true, has_time: true},
              {code: "time", name: "Time", has_length: false, has_placeholder: false, has_default: true, has_time: true}, */
    ];
    return {
      TYPE_LIST: TYPE_LIST,
      TYPE_LIST_CODE: _.keyBy(TYPE_LIST, "code"),
    };
  },
  computed: {
    hasLength: function () {
      if (this.field && this.field.params.type)
        return this.TYPE_LIST_CODE[this.field.params.type].has_length;

      return false; // default to false..
    },
    hasPlaceholder: function () {
      if (this.field && this.field.params.type)
        return this.TYPE_LIST_CODE[this.field.params.type].has_placeholder;

      return false; // default to false
    },
    hasDefault: function () {
      if (this.field && this.field.params.type)
        return this.TYPE_LIST_CODE[this.field.params.type].has_default;

      return false; // default to false
    },
    /* hasTime: function  () {
            if(this.field && this.field.params.type)
              return this.TYPE_LIST_CODE[this.field.params.type].has_time
          } */
  },
};
</script>
